import React from 'react'
import { GridList} from 'material-ui/GridList';

const OutreachGrid = ({
  activePage,
  cards,
  className,
  columnCount,
  perPage,
  rowCount
}) => {

  const rows = rowCount || perPage/columnCount

  return (
    <GridList
      cellHeight={600}
      className={className}
      cols={columnCount}
      rows={rows}
      padding={20}>
      {cards}
    </GridList>
  )
}

export default OutreachGrid



// WEBPACK FOOTER //
// ./src/components/Outreach/OutreachGrid.js